// @flow
import React, { Component, Fragment } from "react";

import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

import {
  GeneralModalForm,
  LoadingProgress,
  ConfirmCancelDialog
} from "imagus-components";
import EmailLicenceForm from "../../containers/licences/EmailLicenceForm";

type DeviceItemStatesType = {
  modalOpen: boolean,
  dialogOpen: boolean
};

type DeviceItemPropsType = {
  device: { [key: string]: * },
  isExpired: boolean,
  index: number,
  isImagusAdmin?: boolean,
  licenceId: string,
  licenceUuid: string,
  downloadLicence: Function,
  unAssignDevice: Function,
  doneCall: Function,
  failCall: Function,
  setLoading: Function
};

class DeviceItem extends Component<DeviceItemPropsType, DeviceItemStatesType> {
  constructor(props: DeviceItemPropsType) {
    super(props);
    this.state = {
      modalOpen: false,
      dialogOpen: false
    };
  }

  switchModalStatus = (modalName: string): * => (status: boolean): * => {
    this.setState({ [modalName]: status });
  };

  downloadLicence = async (host_id: string, is_old: boolean): * => {
    this.props.setLoading();
    this.props.downloadLicence(
      host_id,
      this.props.licenceId,
      is_old,
      this.props.doneCall,
      this.props.failCall
    );
  };

  unassignDevice = async (host_id: string): * => {
    this.props.unAssignDevice(
      JSON.stringify([host_id]),
      this.props.licenceId,
      this.props.licenceUuid,
      this.doneDialogCall(host_id),
      this.props.failCall
    );
  };

  doneDialogCall = (hostId: string): * => {
    this.props.doneCall();
    this.switchModalStatus("dialogOpen")(false);
  };

  render(): * {
    const { device, isExpired, index } = this.props;
    return (
      <TableRow>
        <TableCell className="normal">{index + 1}</TableCell>
        <TableCell className="normal" style={{ wordBreak: "break-all" }}>
          {device.hostId}
        </TableCell>
        <TableCell className="normal">{device.lastUpdatedBy}</TableCell>
        {this.props.isImagusAdmin && (
          <TableCell>
            <Button
              color="primary"
              type="button"
              disabled={isExpired}
              className={isExpired ? "" : "link-btn"}
              onClick={(): * => this.switchModalStatus("dialogOpen")(true)}
            >
              Unassign
            </Button>
            <ConfirmCancelDialog
              open={this.state.dialogOpen}
              handleModalStatus={this.switchModalStatus("dialogOpen")}
              deleteFunction={(): * => this.unassignDevice(device.hostId)}
              deleteWord="Unassign"
              itemName={device.hostId}
              extraWord="from the Licence"
            />
          </TableCell>
        )}
        <TableCell>
          <Button
            color="primary"
            type="button"
            disabled={isExpired}
            className={isExpired ? "" : "link-btn"}
            onClick={(): * => this.downloadLicence(device.hostId, false)}
          >
            Download Licence
          </Button>
        </TableCell>
        {this.props.isImagusAdmin && (
          <Fragment>
            <TableCell>
              <Button
                color="primary"
                type="button"
                disabled={isExpired}
                className={isExpired ? "" : "link-btn"}
                onClick={(): * => this.downloadLicence(device.hostId, true)}
              >
                Download Old Licence
              </Button>
            </TableCell>
            <TableCell>
              <Button
                color="primary"
                type="button"
                disabled={isExpired}
                className={isExpired ? "" : "link-btn"}
                onClick={(): * => this.switchModalStatus("modalOpen")(true)}
              >
                Email Licence
              </Button>
              <GeneralModalForm
                title={"Email Licence"}
                open={this.state.modalOpen}
                handleModalStatus={this.switchModalStatus("modalOpen")}
                form={
                  <EmailLicenceForm
                    onClose={(): * =>
                      this.switchModalStatus("modalOpen")(false)
                    }
                    hostId={device.hostId}
                    licenceId={this.props.licenceId}
                  />
                }
              />
            </TableCell>
          </Fragment>
        )}
      </TableRow>
    );
  }
}

type LicenceDeviceStatesType = {
  loading: boolean
};

type LicenceDevicePropsType = {
  devices: Array<*>,
  facebaseUuid: string,
  isExpired: boolean,
  licenceId: string,
  licenceUuid: string,
  setActionError: Function,
  unAssignDevice: Function,
  downloadLicence: Function,
  isImagusAdmin?: boolean
};

class LicenceDevice extends Component<
  LicenceDevicePropsType,
  LicenceDeviceStatesType
> {
  constructor(props: LicenceDevicePropsType) {
    super(props);
    this.state = {
      loading: false
    };
  }

  setLoading = (): * => {
    this.setState({ loading: true });
  };

  doneCall = (): * => {
    this.setState({ loading: false });
    this.props.setActionError({});
  };

  failCall = (errors: Object): * => {
    this.props.setActionError(errors);
    this.setState({ loading: false });
  };

  render(): * {
    const devices = this.props.devices;
    const facebaseUuid = this.props.facebaseUuid;
    const isExpired = this.props.isExpired;
    const deviceList =
      devices &&
      devices.map((device: *, i: number): ?React.Node => (
        <DeviceItem
          device={device}
          isExpired={isExpired}
          index={i}
          key={i}
          isImagusAdmin={this.props.isImagusAdmin}
          licenceId={this.props.licenceId}
          licenceUuid={this.props.licenceUuid}
          downloadLicence={this.props.downloadLicence}
          unAssignDevice={this.props.unAssignDevice}
          doneCall={this.doneCall}
          failCall={this.failCall}
          setLoading={this.setLoading}
        />
      ));

    if (devices === undefined || this.state.loading) {
      return (
        <div className="app-panel-content panel-top-margin">
          <LoadingProgress size={50} />
        </div>
      );
    } else {
      return (
        <div className="app-panel-content panel-top-margin">
          {deviceList.length > 0 && (
            <Grid container spacing={8}>
              <Grid item xs={12} style={{ maxWidth: "1160px" }}>
                <Paper>
                  <Table className="app-table green center">
                    <TableHead>
                      <TableRow className="active">
                        <TableCell className="blue-shine">S/N</TableCell>
                        <TableCell className="blue-shine">
                          Device / Host ID
                        </TableCell>
                        <TableCell className="blue-shine">
                          Assigned By
                        </TableCell>
                        <TableCell
                          className="blue-shine"
                          colSpan={this.props.isImagusAdmin ? 4 : 1}
                        >
                          Actions
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>{deviceList}</TableBody>
                  </Table>
                </Paper>
              </Grid>
            </Grid>
          )}
        </div>
      );
    }
  }
}

export default LicenceDevice;
